export default __webpack_public_path__ + "static/media/checklistIcon.54c72cb3.svg";